import useSWRImmutable from 'swr/immutable';
import GeneralService from '@/services/SettingsServices/GeneralService';

const useAgencyCurrency = () => useSWRImmutable(
    'agency-currency',
    GeneralService.getAgencyCurrency,
);

export default useAgencyCurrency;
